var map = {
	"./br/PT/S1/gm1.png": 48679,
	"./in/EN/S1/gm1.png": 15903,
	"./ph/EN/S1/gm1.png": 14233,
	"./vn/VI/S1/gm1.png": 47387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90675;